import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initGoogleServices } from './lib/googleAnalytics.ts';

// Initialize dynamic GTM and Google Analytics services with proper consent state
initGoogleServices();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
